import consumer from "../consumer"
import Rails from '@rails/ujs'

consumer.subscriptions.create("Marketing::ShowroomChannel", {
    // Called once when the subscription is created.
    initialized() {
	this.update = this.update.bind(this)
    },

    // Called when the subscription is ready for use on the server
    connected() {
	this.install()
    },

    // Called when the subscription has been terminated by the server
    disconnected() {
	this.uninstall()
    },

    // Called when there's incoming data on the websocket for this channel
    received(data) {
    },

    // Called when the subscription is rejected by the server.
    rejected() {
	this.uninstall()
    },

    update(event) {
    },

    install() {
	//document.addEventListener("submit", this.update)
    },

    uninstall() {
	//document.removeEventListener("submit", this.update)
    }
});
